import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import dsvLogo from "../images/dsv-logo.png";
import HeaderMenu from "./Menu";
import SmallScreenMenu from "./SmallScreenMenu";
import AppHelper from "../Helper/AppHelper";
import NavBar from "./Menu/NavBar";
 

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

const drawerWidth = 240;

export default function Header(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isUserLogin, setisUserLogin] = React.useState(false);
  const [showNavBar , setshowNavBar] = React.useState(false);
  
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const useEffectCount = React.useRef(true);
  React.useEffect(() => {
    if (useEffectCount.current) {
      useEffectCount.current = false;

      if (AppHelper.getUser().id !== 0) {
        setisUserLogin(true);
      }     
    
     
       if (AppHelper.getUser().isMDMActive === true || (AppHelper.getUser().userType == "Super Admin" || AppHelper.getUser().userType == "Admin")) {
        setshowNavBar(true);
        
      }
    }
  }, []);

  const closeDrawer = ()=> {
    setMobileOpen(false);
  }

  return (
    <>
      {" "}
      <CssBaseline />
      <AppBar component="nav" className="new-header"> 
        <Toolbar>      { 
                
             isUserLogin === true && showNavBar && (
            <NavBar/> )}
          <a href="/">
            <img src={dsvLogo} className="dsv-logo" />
          </a>
          </Toolbar>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <HeaderMenu></HeaderMenu>
          </Box>
       
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <SmallScreenMenu handleDrawerToggle={closeDrawer}></SmallScreenMenu>
        </Drawer>
      </Box>
    </>
  );
}
